import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { ApiService } from "src/app/services/api.service";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup } from "@angular/forms";
import { CommonService } from "src/app/services/common.service";
import { Subject } from "rxjs";
import endpoints from "src/app/helpers/endpoints";
import { takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import { EventService } from "src/app/services/event.service";
import { ClaimActionsService } from "src/app/pages/customer-dashboard/services/claim-actions.service";
import { CreatePurchaseItemComponent } from "../modal/create-purchase-item/create-purchase-item.component";

@Component({
  selector: "fury-purchased-item-list",
  templateUrl: "./purchased-item-list.component.html",
  styleUrls: ["./purchased-item-list.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class PurchasedItemListComponent implements OnInit, OnDestroy {
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  @Input()
  columns = [
    { name: "Item Name", property: "itemName", visible: true },
    { name: "Item Parts", property: "itemParts", visible: true },
    { name: "Color", property: "color", visible: true },
    { name: "Status", property: "status", visible: true },
    { name: "Supplier", property: "supplier", visible: true },
    { name: "Order Number", property: "orderNumber", visible: true },
    { name: "Order Date", property: "orderDate", visible: true },
    { name: "Total Amount", property: "totalAmount", visible: true },
    { name: "Delivery Date", property: "deliveryDate", visible: true },
    { name: "Tracking", property: "tracking", visible: true },
    { name: "Note", property: "note", visible: true },
    { name: "Actions", property: "actions", visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue = "Purchased Items";
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  ngUnsubscribe = new Subject<void>();
  purchaseItem = new FormGroup({
    itemName: new FormControl(""),
    itemParts: new FormControl(""),
    color: new FormControl(""),
    status: new FormControl(""),
    supplier: new FormControl(""),
    orderNumber: new FormControl(""),
    totalAmount: new FormControl(""),
    tracking: new FormControl(""),
  });
  claimId = "";
  statusList = ["Ordered", "In Transit", "Received"];

  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService,
    public claimActionsService: ClaimActionsService
  ) {}
  ngOnInit() {
    this.router.onSameUrlNavigation = "reload";
    this.claimId = this.activatedRoute.snapshot.params.claimId;
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.pageIndex = res.page ? res.page - 1 : 0;
        this.pageSize = res.size ? (res.size === "all" ? 9999 : res.size) : 30;
        this.getPurchaseClaimsItems();
      });
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/file-claim/purchase-claim/purchased-items/${this.claimId}?page=${this.pageIndex + 1}${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }`
    );
  }

  getPurchaseClaimsItems() {
    const {itemName, itemParts, color, status, supplier, orderNumber, totalAmount, tracking} = this.purchaseItem.value;
    const queryParams = `?page=${Number(this.pageIndex) + 1}&size=${this.pageSize}&itemName=${itemName}&itemParts=${itemParts}&color=${color}&supplier=${supplier}&orderNumber=${orderNumber}&tracking=${tracking}&totalAmount=${totalAmount}&status=${status}`;
    this.apiservice
      .get(`${endpoints.fileAClaim.getPurchaseClaimItems(this.claimId)}${queryParams}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            if (res?.body?.purchaseItems) {
              this.itemList = res?.body?.purchaseItems?.data;
              this.totalCount = res?.body?.purchaseItems.total;
              this.dataSource = new MatTableDataSource(this.itemList);
              this.cdr.detectChanges();
            } else {
              this.itemList = undefined;
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.apiservice.alert(err.message, ErrorType.Error);
        }
      );
  }

 
  handlePurchaseItemModal(isCreateType: boolean, row?: any) {
    const purchaseData = {
      claimId: isCreateType ? [this.claimId] : this.claimId,
      purchaseItem: row || null,
    }
    this.dialog
      .open(CreatePurchaseItemComponent, {
        width: "800px",
        data: purchaseData,
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: any) => {
          if(res){
            this.getPurchaseClaimsItems();
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
